import React from 'react'
import Layout from './Layout'
import {style} from 'glamor'

export default ({children}) => (
  <Layout>
    <div
      {...style({
        height: '100%',
        flex: '1 1 auto',
        marginRight: '1rem',
      })}
    >
        {children[0]}
    </div>
    <div
      {...style({
        height: '100%',
        flex: '1 1 auto',
      })}
    >
        {children[1]}
    </div>
  </Layout>
)



/** WEBPACK FOOTER **
 ** ./src/components/Layout2.js
 **/